import { listTransactionCustomColumns } from './transaction-custom-column-value.js';

// #6275: shared by the Ledgers and Events & Transactions inline editors, which
// used to force every custom column through the currency editor.

/** Text columns (the default) edit as free text; every other format keeps the currency editor. */
export function isTextCustomColumn(clientData, colKey) {
	const col = listTransactionCustomColumns(clientData).find((c) => c.key === colKey);
	return (col?.format || 'text') === 'text';
}

/** Value to save from the cell's raw text, or null to revert the edit. Empty text clears the value. */
export function parseInlineCustomValue(isText, raw) {
	const text = String(raw ?? '').trim();
	if (isText) return text;

	const withoutDollar = text.replace(/^\$/, '').trim();
	if (withoutDollar === '') return null;
	const cleaned = withoutDollar.replace(/[^.\d]/g, '');
	return cleaned === '' || isNaN(Number(cleaned)) ? null : cleaned;
}

/** Cell text after a successful edit. */
export function formatInlineCustomDisplay(isText, value, currencyFormat) {
	if (isText) return value;
	const num = Number(value);
	return num ? num.toLocaleString('en-US', currencyFormat) : 'n.a.';
}

/**
 * #6405: value to store from an imported cell. Currency/number cells lose `$`, commas and spaces
 * (so a Ledgers export re-imports cleanly), but anything that isn't then a number is kept as typed.
 */
export function parseImportedCustomValue(format, raw) {
	const text = String(raw ?? '').trim();
	if (format !== 'currency' && format !== 'number') return text;
	if (text.toLowerCase() === 'n.a.') return '';
	const cleaned = text.replace(/[$,\s]/g, '');
	return cleaned !== '' && !isNaN(Number(cleaned)) ? cleaned : text;
}
